import api from "APP_ROOT/api";
import * as actionTypes from "MODULES/shared/actionTypes";
import { SUCCESS } from "LIB/submission/constants";
import { isEmpty } from "lodash";

export const actionFactory = (t, r) => `${t}_${r}`;

export function getNotes(id, type, notesType) {
  return dispatch => {
    dispatch({
      type: [actionFactory(actionTypes.GET_NOTES, type)],
      notesType
    });

    return api.notes.index(id, type, notesType).then(resp =>
      dispatch({
        type: [actionFactory(actionTypes.SET_NOTES, type)],
        notes: resp.data.results,
        notesType
      })
    );
  };
}

export function createNote(id, type, data, notesType) {
  const note = Object.assign({}, data);

  if (notesType === "internal") {
    note.internal_note = true;
  } else if (notesType === "external") {
    note.external_note = true;
  } else if (!isEmpty(notesType)) {
    note.note_type = notesType;
  }

  return dispatch =>
    api.notes.create(id, type, note).then(resp => {
      dispatch({
        type: [actionFactory(actionTypes.ADD_NOTE, type)],
        note: resp.data,
        notesType
      });
      return SUCCESS;
    });
}

export function editNote(id, type, data, notesType) {
  return dispatch =>
    api.notes.update(id, type, data).then(resp => {
      dispatch({
        type: [actionFactory(actionTypes.UPDATE_NOTE, type)],
        note: resp.data,
        notesType
      });
      return SUCCESS;
    });
}

export function removeNote(id, type, note, notesType) {
  return dispatch =>
    api.notes.delete(id, type, note.toJS()).then(() => {
      dispatch({
        type: [actionFactory(actionTypes.REMOVE_NOTE, type)],
        id: note.get("id"),
        notesType
      });
      return SUCCESS;
    });
}



// WEBPACK FOOTER //
// ./app/modules/shared/actions/notes.js